import { FC, PropsWithChildren, Suspense } from 'react';

import { BaseLoader } from '../../molecules/BaseLoader';
import { ExternalPortal } from '../../protons/ExternalPortal/ExternalPortal';
import { BackgroundDimmerNaked } from '../BackgroundDimmer';

import { DEFAULT_DRAWER_WIDTH } from './Drawer.constants';
import { $BlockContainer } from './Drawer.styles';
import { DrawerPosition } from './Drawer.types';
import DrawerContent from './DrawerContent';

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  width?: number;
  withPadding?: boolean;
  dataTestId?: string;
  position?: DrawerPosition;
}

const Drawer: FC<PropsWithChildren<DrawerProps>> = ({
  isOpen,
  children,
  onClose,
  width = DEFAULT_DRAWER_WIDTH,
  withPadding = true,
  dataTestId,
  position = DrawerPosition.Left,
}) => {
  if (!isOpen) {
    return <></>;
  }

  return (
    <Suspense fallback={<BaseLoader />}>
      <ExternalPortal>
        <$BlockContainer $position={position}>
          <BackgroundDimmerNaked onClick={onClose} $zIndex={0} $opacity={0.5} />
          <DrawerContent
            withPadding={withPadding}
            width={width}
            onClose={onClose}
            dataTestId={dataTestId}
            position={position}
          >
            {children}
          </DrawerContent>
        </$BlockContainer>
      </ExternalPortal>
    </Suspense>
  );
};

export default Drawer;
